module.exports = __webpack_public_path__ + "static/media/left-arrow.6efce20a.png";